import React, { useMemo } from 'react';
import { ButtonClean, Fieldset } from '@fourthwall/components';
import { FormFields } from '../../hooks/useBadgeForm/types';
export const AddAnotherStreak = ({ form }) => {
    const lastStreak = form.values.memberStreakBadges[form.values.memberStreakBadges.length - 1];
    const lastMonthTo = lastStreak?.monthsTo;
    const monthsTo = useMemo(() => {
        if (!lastMonthTo)
            return 0;
        if (lastMonthTo === 60)
            return 0;
        if (lastMonthTo === 0)
            return 0;
        return lastMonthTo + 1;
    }, [lastMonthTo]);
    return (React.createElement(Fieldset.Row, null,
        React.createElement(ButtonClean, { label: "Add another streak", onClick: () => {
                form.setFieldValue(FormFields.memberStreakBadges, form.values.memberStreakBadges.concat({
                    emoji: {
                        type: 'Emoji',
                        emojiIcon: '😊',
                    },
                    borderColor: undefined,
                    backgroundColor: 'rgba(0,0,0,0)',
                    textColor: undefined,
                    monthsFrom: lastMonthTo,
                    monthsTo,
                }));
            } })));
};
